import IconDiscordBands from '@/assets/icons/font_awesome/discord-brands.svg?react';
import IconFacebookBrands from '@/assets/icons/font_awesome/facebook-brands.svg?react';
import IconGithubBrands from '@/assets/icons/font_awesome/github-brands.svg?react';
import IconGoogleBrands from '@/assets/icons/font_awesome/google-brands.svg?react';
import IconMicrosoftBands from '@/assets/icons/font_awesome/microsoft-brands.svg?react';
import { UI_PRIMITIVE__card_content } from '@/components/ui/card/card';
import { UI_PRIMITIVE__icon_animated } from '@/components/ui/UI_PRIMITIVE__icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import { ButtonSocialNetwork } from '@/pages/_base/buttons/ButtonSocialNetwork';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { ENUM__http_route } from '@shared/network/ENUM__http_route';
import { useTranslation } from 'react-i18next';

export function ViewEnterWithSocialNetworks() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);

  let icon_props = {
    className: '!w-4 !h-4',
    renderDelay: CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER,
  };

  return (
    <UI_PRIMITIVE__card_content className="p-0 text-bar-foreground">
      <h2 className={`mb-4 text-lg font-semibold ${md(' text-center font-bold', '')}`}>{t(i18n_page_auth.auth_component.title.login_with_social_networks)}</h2>
      <div className={`flex flex-col justify-between  ${md(' h-[20rem] mt-10', ' h-[14.5rem]')} `}>
        <ButtonSocialNetwork start_slug={ENUM__http_route.GOOGLE_AUTH_START}>
          <UI_PRIMITIVE__icon_animated Icon={IconGoogleBrands} {...icon_props} />
          {t(i18n_page_auth.auth_component.button.get_started_with_google)}
        </ButtonSocialNetwork>
        <ButtonSocialNetwork start_slug={ENUM__http_route.MICROSOFT_AUTH_START}>
          <UI_PRIMITIVE__icon_animated Icon={IconMicrosoftBands} {...icon_props} />
          {t(i18n_page_auth.auth_component.button.get_started_with_microsoft)}
        </ButtonSocialNetwork>
        <ButtonSocialNetwork start_slug={ENUM__http_route.GITHUB_AUTH_START}>
          <UI_PRIMITIVE__icon_animated Icon={IconGithubBrands} {...icon_props} />
          {t(i18n_page_auth.auth_component.button.get_started_with_github)}
        </ButtonSocialNetwork>
        <ButtonSocialNetwork start_slug={ENUM__http_route.DISCORD_AUTH_START}>
          <UI_PRIMITIVE__icon_animated Icon={IconDiscordBands} {...icon_props} />
          {t(i18n_page_auth.auth_component.button.get_started_with_discord)}
        </ButtonSocialNetwork>
        <ButtonSocialNetwork start_slug={ENUM__http_route.FACEBOOK_AUTH_START}>
          <UI_PRIMITIVE__icon_animated Icon={IconFacebookBrands} {...icon_props} />
          {t(i18n_page_auth.auth_component.button.get_started_with_facebook)}
        </ButtonSocialNetwork>
      </div>
    </UI_PRIMITIVE__card_content>
  );
}
